class CollectionListCustomSlider extends HTMLElement {
  constructor() {
    super();
    this.initSlider = this.initSlider.bind(this);
    this.swiper = null;
    
    // Support for Shopify theme editor
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => {
        if (e.target.contains(this)) this.initWhenReady();
      });
      document.addEventListener('shopify:block:select', (e) => {
        if (e.target.closest('collection-list-custom-slider') === this && this.swiper) {
          const blocks = Array.from(this.querySelectorAll('.swiper-slide'));
          const index = blocks.indexOf(e.target);
          if (index !== -1) {
             this.swiper.slideTo(index);
          }
        }
      });
    }
  }

  connectedCallback() {
    this.initWhenReady();
  }

  initWhenReady() {
    // Check if Swiper is loaded, if not, wait for it.
    if (typeof Swiper !== 'undefined') {
      this.initSlider();
    } else {
      const checkSwiper = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          this.initSlider();
        }
      }, 100);
      
      // Safety timeout
      setTimeout(() => clearInterval(checkSwiper), 5000);
    }
  }

  updateNavigationPosition() {
    const firstMedia = this.querySelector('.collection-list-custom__media');
    if (firstMedia) {
      const mediaHeight = firstMedia.offsetHeight;
      const buttons = this.querySelectorAll('.swiper-button-next, .swiper-button-prev');
      buttons.forEach(btn => {
        btn.style.top = `${mediaHeight / 2}px`;
      });
    }
  }

  initSlider() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) return;

    const desktopColumns = parseInt(this.dataset.desktopColumns) || 3;
    const mobileColumns = parseInt(this.dataset.mobileColumns) || 1;
    const totalSlides = parseInt(this.dataset.totalSlides) || 0;
    const tabletColumns = Math.min(2, desktopColumns - 1);

    const breakpointsConfig = {
      // when window width is >= 750px
      750: {
        slidesPerView: totalSlides > tabletColumns ? tabletColumns + 0.5 : tabletColumns,
        spaceBetween: 22,
      },
      // when window width is >= 990px
      990: {
        slidesPerView: totalSlides > desktopColumns ? desktopColumns + 0.5 : desktopColumns,
        spaceBetween: 32,
      }
    };

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: totalSlides > mobileColumns ? mobileColumns + 0.2 : mobileColumns,
      spaceBetween: 16,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      watchOverflow: true,
      breakpoints: breakpointsConfig,
      on: {
        init: () => {
          this.updateNavigationPosition();
          setTimeout(() => this.updateNavigationPosition(), 5000);
        },
        resize: () => this.updateNavigationPosition()
      }
    });
  }
}

if (!customElements.get('collection-list-custom-slider')) {
  customElements.define('collection-list-custom-slider', CollectionListCustomSlider);
}
